<template>
  <div class="page-content">
    <div class="title">
      Sitemaps settings
    </div>
    <div class="list" v-if="!loading">
      <div class="box">
        <template v-if="!procedureLast || procedureLast.dateFinished != null">
          <a class="btn-dark-button" @click="excecuteProcedure()"
            >Recreate Sitemap now</a
          >
          <template v-if="procedureLast">
            <p>
              Excecuted last time on: {{ procedureLast.dateFinished }} by
              {{ procedureLast.user }}
            </p>
            <template v-if="procedureLast.success == '1'">
              <p class="success">
                Last process was successfull
              </p>
              <p v-if="sites.length">{{ procedureLast.note }}</p>
            </template>
            <template v-else>
              <p class="error">
                Last process fail
              </p>
              <p v-if="lastError" class="error">{{ lastError }}</p>
            </template>
            <div v-for="site in sites" :key="site.host" class="site">
              <div class="site-host">{{ site.host }}</div>
              <ul>
                <li v-for="file in site.files" :key="file.name">
                  <a :href="file.url" target="_blank" rel="noopener">{{
                    file.file
                  }}</a>
                  <span v-if="file.urls" class="detail">
                    {{ file.urls }} URLs</span
                  >
                  <span v-if="file.status == 'invalid'" class="error">
                    invalid</span
                  >
                </li>
              </ul>
            </div>
          </template>
        </template>
        <template v-else>
          <BaseSmallSpinner />
          Recreate in progress...
          <template>
            <br />
            <br />
            Is this proccess taking too long?
            <a v-if="!cancelling" @click="cancelProcess()">cancel now</a>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getProcedures,
  requestCancelProcess
} from "@/api/store/ProcedureService.js";
import { generateSitemap } from "@/api/store/SitemapService.js";
const PROCEDURE_NAME = "sitemap_generation";
const CURRENT_PROCEDURE = "sitemap";
export default {
  data() {
    return {
      procedures: [],
      loading: true,
      interval: null,
      skipRefresh: false,
      cancelling: false
    };
  },
  computed: {
    procedureLast() {
      if (this.procedures.length == 0) {
        clearInterval(this.interval);
        return null;
      } else {
        const recreate = this.procedures.filter(x => {
          return x.procedureName == PROCEDURE_NAME;
        });
        if (recreate[0].dateFinished) {
          clearInterval(this.interval);
        }
        return recreate[0];
      }
    },
    // El resultado de la última generación (status_json): un fichero por fila
    // con su URL pública, "dominio/fichero" como nombre. Las generaciones
    // anteriores al sitemap por dominio no lo guardan y no listan nada.
    lastResult() {
      try {
        return JSON.parse(this.procedureLast?.statusJson || "null");
      } catch (e) {
        return null;
      }
    },
    lastError() {
      return this.lastResult?.error || null;
    },
    sites() {
      if (!Array.isArray(this.lastResult)) return [];
      const sites = {};
      this.lastResult
        .filter(row => row.url)
        .forEach(row => {
          const [host, file] = row.name.split("/");
          sites[host] = sites[host] || { host, files: [] };
          sites[host].files.push({ ...row, file });
        });
      return Object.values(sites);
    }
  },
  mounted() {
    this.getProcedureLogs();
    this.interval = setInterval(() => {
      if (!this.skipRefresh) {
        this.getProcedureLogs();
      }
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async getProcedureLogs() {
      this.procedures = await getProcedures(CURRENT_PROCEDURE);
      this.loading = false;
      if (this.procedureLast.dateFinished) {
        this.cancelling = false;
      }
    },
    async excecuteProcedure() {
      generateSitemap();
      this.procedures.unshift({
        procedureName: PROCEDURE_NAME,
        dateFinished: null
      });
      this.interval = setInterval(() => {
        this.getProcedureLogs();
      }, 5000);
    },
    cancelProcess() {
      this.cancelling = true;
      requestCancelProcess(CURRENT_PROCEDURE, PROCEDURE_NAME);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/App.scss";
.list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  .box {
    margin: 10px;
    width: 350px;
    padding: 20px;
    @extend .shadow-4dp;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    text-align: center;
    position: relative;
    flex-direction: column;
    .options {
      display: none;
    }
    a {
      color: red;
    }
    .site {
      width: 100%;
      margin-top: 15px;
      text-align: left;
      .site-host {
        font-weight: bold;
        margin-bottom: 5px;
      }
      ul {
        margin: 0;
        padding-left: 18px;
      }
      li {
        margin-bottom: 3px;
      }
      .detail {
        color: $M8;
      }
    }
    &:hover {
      .options {
        display: block;
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: row;
        .icon {
          border: 1px solid $M8;
          border-radius: 10px;
          padding: 5px;
          width: 30px;
          margin-left: 5px;
          &:hover {
            background-color: $M8;
          }
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
